var Vendd = (function (Vendd) {
    'use strict';

    Vendd.MessageBus.subscribe(Vendd.CustomForms.Messages.SendNotification, Vendd.CustomForms, function (envelope) {
        var options = {
            url: 'SendNotificationsToUser',
            data:
            {toemail:envelope.message.data.toemail,
            fromemail: envelope.message.data.fromemail,
            relatedObjectid: envelope.message.data.relatedObjectid,
            langCode: envelope.message.data.langCode,
            notificationTemplateCode: envelope.message.data.notificationTemplateCode,
            param: envelope.message.data.param,
            },
            servicenamespace:'services/api/notification',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.CustomForms, new Vendd.CustomForms.Messages.SendNotificationSuccess(response));
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.CustomForms, new Vendd.CustomForms.Messages.SendNotificationFailure(response));
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.CustomForms.Messages.Submit, Vendd.CustomForms, function (envelope) {
        var options = {
            url: 'SubmitCustomForm',
            data: JSON.stringify(envelope.message.data),
            rawdata: true,
            servicenamespace: 'services/api/notification',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.CustomForms, new Vendd.CustomForms.Messages.SubmitSuccess(response));
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.CustomForms, new Vendd.CustomForms.Messages.SubmitFailure(response));
        };

        Vendd.Service.call(options);
    });



    return Vendd;

})(Vendd || {});